import { api, apiPublic } from '../../api/client';
import type { TelemetrySummary } from './types';

export async function postTelemetryEvents(
  visitorId: string,
  events: { path: string; occurredAt?: string }[]
): Promise<void> {
  if (events.length === 0) return;
  await apiPublic.post<void>('/api/telemetry/events', { visitorId, events });
}

export async function purgeAnonymousTelemetry(visitorId: string): Promise<number> {
  const res = await api.post<{ deletedCount: number }>('/api/telemetry/purge-anonymous', { visitorId });
  return res.deletedCount;
}

export async function fetchTelemetrySummary(): Promise<TelemetrySummary> {
  return api.get<TelemetrySummary>('/api/telemetry/summary');
}
